import React, { useContext, useState } from 'react';  
import {  Button, TextField, Link, Box, Grid, Typography, CircularProgress } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { userSignin } from 'core/services/auth';
import { useNavigate, Link as RouteLink } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { AuthContext } from 'core/context';
import LoginIcon from '@mui/icons-material/Login';
const SignIn = () => {

  /* Hooks */
  const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [isSiningIn, setSiningIn] = useState(false)
  const { handleSubmit, control, formState: { errors } } = useForm({
    defaultValues: {
      mobile: '',
      password:''
    }
  });

  const onSubmit = (data) => {
    setSiningIn(true);
    userSignin(data).then(({ response, error }) => {
      setSiningIn(false);
      if(response){
        authContext.updateAuthContext({
          isUserLoggedIn: true,
          authToken: response?.authToken,
          userId: response?.userEntity?.userId,
          data: {
            name: `${response?.userEntity?.firstName} ${response?.userEntity?.lastName}`,
            email: response?.userEntity?.email,
          }
        });
        navigate('/overview');
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  };

  return (
    <Box
      sx={{
        mx: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography component="h1" variant="h5">
        Signin to your account
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
        <Controller
          control={control}
          name="mobile"
          id="mobile"
          autoComplete="mobile"
          rules={{ required: "Enter your mobile",
            pattern: {
              value: /^[0-9]{10}$/i,
              message: "Enter a valid 10 digit mobile number",
            },
            // maxLength: 10,
          }}
          render={({field }) => (
            <TextField
              {...field}
              margin="normal"
              fullWidth
              autoFocus
              label="Mobile Number"
              required
              error={errors.mobile}
              helperText={errors.mobile?.message}
              // maxLength={10}
              />
              )}
            />
        <Controller
          control={control}
          name="password"
          id="password"
          rules={{ required: "Please Enter Password" }}
          render={({field}) => (
            <TextField
            {...field}
            margin="normal"
            fullWidth
            label="Password"
            autoComplete="current-password"
            type="password"
            required
            error={errors.password?.type === 'required'}
            helperText={errors.password?.message}
            />
            )}
            />
        <Grid container justifyContent="right" sx={{mt: 1}} >
          <Grid item >
            <Link component={RouteLink} to="/password-reset/" color="secondary">
              Forgot password?
            </Link>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" >
          <Button
            disabled={isSiningIn}
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, px: 3, textTransform: 'inherit' }}
            endIcon={isSiningIn ? <CircularProgress size={20} /> : <LoginIcon /> }
            size="large"
            >
            {isSiningIn ? 'Signing In': 'Sign In'}
          </Button>
          <Grid container justifyContent="center" sx={{mt: .5}} >
            <Grid item  color="primary.dullBlack" >
              Don't have an account? <strong><Link component={RouteLink} to="/register/" color="primary.contrastText">Sign Up</Link></strong>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
 
export default SignIn;
